import { reduxForm } from 'redux-form';
import { compose, withHandlers, withProps, withState } from 'recompose';

import steps from '../PoFormSteps';
import { formConfig } from './formConfig';
import withNewDesignStyles from '../../../../common/hoc/withNewDesignStyles';

const SharedPoFormContainer = compose(
  reduxForm(formConfig),
  withNewDesignStyles,
  withState('activeStep', 'setActiveStep', 0),
  withProps((props) => {
    const activeStep = steps[props.activeStep];
    return {
      canGoBack: props.activeStep > 0 && !props.isOrderGenerated,
      canGoForward: props.valid && props.activeStep < steps.length - 1,
      canSubmit: props.valid && props.activeStep === steps.length - 1 && !props.isOrderGenerated,
      canCancel: !props.isOrderGenerated,
      isLastStep: props.activeStep === steps.length - 1,
      StepComponent: activeStep.component,
      name: activeStep.name,
    };
  }),
  withHandlers({
    submit: props => (values) => {
      if (props.canSubmit) {
        props.submitOrder(values);
        return;
      }

      if (!props.canGoForward) {
        return;
      }

      const nextStep = props.activeStep + 1;
      props.setActiveStep(nextStep);
    },
    goBack: props => () => {
      if (props.canGoBack) {
        props.setActiveStep(props.activeStep - 1);
      }
    },
    goToStep: props => (step) => {
      if (props.step >= step) {
        props.setActiveStep(step);
      }
    },
  }),
);

export default SharedPoFormContainer;
